import { history } from 'umi';
import { getTopList } from '@intelligence/v3/utils/topcharts';

/**
 * 获取前n个国家（默认勾选的）
 * @param list Market Profile页面列表数据
 * @return 前n个国家（默认勾选的）
 */
export const getTopCountries = (list?: IGenreMarketProfile[] | null): string[] => {
  if (!Array.isArray(list) || list.length === 0) return [];
  return getTopList<IGenreMarketProfile>(list).map((item) => item?.market);
};

/**
 * 生成Market Profile页面Global Performance模块世界地图数据
 * @param countryMap 国家映射（全局定义的）
 * @param list Market Profile页面列表数据
 * @param metric 指标key
 */
export const getMarketProfileMapChartData = (
  countryMap: IRecord<IRegionCountryEntity>,
  list: IGenreMarketProfile[] | null,
  metric: IPrimaryKeyMetric,
): IMapChartData[] => {
  if (!Array.isArray(list) || list.length === 0) return [];
  return list
    .filter((item) => {
      const countryCode = item?.market || '';
      // Filter out global aggregations - they should not be displayed on the map
      return countryCode !== 'global' && countryCode !== 'global_wo_china';
    })
    .map((item) => {
      const countryCode = item?.market || '';
      const gameCountKey = `${metric?.dataSource}__game_count`;
      return {
        name: countryMap?.[countryCode]?.country_name_en || '',
        value: Number.parseInt(item?.[metric?.key] as string, 10) ?? null,
        payload: {
          gameCount: item?.[gameCountKey],
        },
      };
    });
};

export const getMarketProfileLineChartData = (
  list: IGenreMarketProfile[] | null,
  metric: IPrimaryKeyMetric,
  countries: string[],
) => {
  if (!Array.isArray(list) || list.length === 0) return [];
  return list
    .filter((item) => countries?.includes(item?.market))
    .map((item) => {
      return {
        date: item?.date || '',
        name: item?.market || '',
        value: (item?.[metric?.key] as number) ?? null,
        payload: {
          ...item,
        },
      };
    });
};

/**
 * 跳转Market Profile详情页的路由的参数
 */
interface IMarketProfileDetailsNavigateParams {
  /**
   * 来源页面id
   */
  pageId?: string;
  /**
   * 国家code
   */
  countryCode?: string;
  /**
   * 国家名称（英文）
   */
  countryName?: string;
}

/**
 * Market Profile详情页路由path
 */
const MARKET_PROFILE_DETAILS_ROUTE_PATH = '/intelligence/MarketProfile/Overview/detail';

/**
 * 获取跳转Market Profile详情页的路由path
 * @param params 参数对象 具体定义参见IMarketProfileDetailsNavigateParams
 */
export const getMarketProfileDetailsRoutePath = (params?: IMarketProfileDetailsNavigateParams | null) => {
  if (!params) return '';
  const pageId = params?.pageId || '';
  const countryCode = params?.countryCode || '';
  const countryName = params?.countryName || '';
  const searchParams = new URLSearchParams({
    pageId,
    marketNameEn: countryCode,
    marketName: countryName,
  });
  return `${MARKET_PROFILE_DETAILS_ROUTE_PATH}?${searchParams.toString()}`;
};

/**
 * 跳转Market Profile详情页
 * @param params 参数对象 具体定义参见IMarketProfileDetailsNavigateParams
 */
export const navigateToMarketProfileDetailsByPath = (params?: IMarketProfileDetailsNavigateParams | null) => {
  if (!params) return;
  const path = getMarketProfileDetailsRoutePath(params);
  if (path) {
    history.push(path);
  }
};
